/**
 * Rango del usuario OBJETIVO de una pantalla de permisos (spec 2026-10-07 §4).
 *
 * Quien mira solo ve los botones «Permisos» de quien tiene MENOS rango
 * (lib/rank.canAdjust). El rol del objetivo sale del espejo público
 * usuarios_rol/{uid} + roles/{rol} (lib/role_mirror.loadTargetRole, con su
 * alcance aplicado), NO de users/{uid}. Si no se puede leer es DESCONOCIDO
 * (null) y no se puede ajustar. Root nunca se ajusta.
 */
import { loadTargetRole } from './role_mirror';
import { canAdjust } from './rank';

export { loadTargetRole };

export const targetRoleOf = (role) => {
  if (!role || typeof role !== 'object') return null;
  if (!role.id) return null;
  return role;
};

export const loadTargetRoles = async ({ db, uids, loadRole = loadTargetRole, known = new Map(), concurrency = 6 }) => {
  const out = new Map(known);
  const todo = [...new Set((uids || []).filter((u) => typeof u === 'string' && u && !out.has(u)))];
  let next = 0;
  const worker = async () => {
    while (next < todo.length) {
      const uid = todo[next];
      next += 1;
      let role = null;
      try {
        // eslint-disable-next-line no-await-in-loop
        role = targetRoleOf(await loadRole({ db, uid }));
      } catch (e) {
        role = null;
      }
      out.set(uid, role);
    }
  };
  await Promise.all(Array.from({ length: Math.min(concurrency, todo.length) }, worker));
  return out;
};

export const canShowPermissions = (viewerRole, targetRole) => (
  !!targetRole
  && !(targetRole.documents && targetRole.documents.root === true)
  && canAdjust(viewerRole, targetRole)
);

export const filterAdjustableStaff = ({ list, viewerRole }) => (Array.isArray(list) ? list : [])
  .filter((s) => canShowPermissions(viewerRole, s && s.role));

export default canShowPermissions;
